import { useEffect, useRef, useState } from "react";
import { Copy, Check } from "lucide-react";

const ORIGIN = process.env.REACT_APP_BACKEND_URL;
const EMBED = `<script\n  src="${ORIGIN}/chatbot-widget.js"\n  data-branch="iec-mustikajaya"\n  data-position="bottom-left"\n  defer>\n</script>`;

export default function WidgetDemo() {
  const injected = useRef(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (injected.current) return;
    injected.current = true;
    const s = document.createElement("script");
    s.src = `${ORIGIN}/chatbot-widget.js`;
    s.setAttribute("data-branch", "iec-mustikajaya");
    s.setAttribute("data-position", "bottom-left");
    s.defer = true;
    document.body.appendChild(s);
  }, []);

  const copy = () => {
    navigator.clipboard.writeText(EMBED).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="min-h-screen bg-white" data-testid="widget-demo-page">
      <header className="bg-[#0f2847] text-white">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="h-9 w-9 rounded-lg bg-[#f97316] grid place-items-center font-bold">IEC</div>
            <span className="font-semibold">IEC Mustikajaya</span>
          </div>
          <nav className="hidden sm:flex gap-6 text-sm text-blue-100">
            <span>Beranda</span><span>Program</span><span>Tentang</span><span>Kontak</span>
          </nav>
        </div>
      </header>

      <section className="bg-slate-50 border-b border-slate-200">
        <div className="max-w-5xl mx-auto px-6 py-16 text-center">
          <p className="text-xs font-semibold text-[#f97316] uppercase tracking-wide">Halaman Demo Website</p>
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-3">Simulasi Website iecmustikajaya.id</h1>
          <p className="text-slate-500 mt-3 max-w-2xl mx-auto text-sm">Halaman ini meniru website WordPress dan memuat widget chatbot melalui kode embed yang sama. Tombol <strong>Tanya IEC</strong> muncul di kanan bawah.</p>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 py-12 grid sm:grid-cols-3 gap-6">
        {["Program Anak & Remaja", "Persiapan TOEFL/IELTS", "Pelatihan Perusahaan"].map((t) => (
          <div key={t} className="border border-slate-200 rounded-xl p-5">
            <h3 className="font-semibold text-slate-800">{t}</h3>
            <p className="text-sm text-slate-500 mt-2">Konten contoh untuk mensimulasikan tampilan website. Klik tombol chatbot untuk mencoba.</p>
          </div>
        ))}
      </section>

      <section className="max-w-5xl mx-auto px-6 pb-20">
        <div className="bg-slate-900 rounded-xl p-5 text-slate-100">
          <div className="flex items-center justify-between mb-3">
            <h2 className="font-semibold text-sm">Kode Embed untuk WordPress</h2>
            <button onClick={copy} data-testid="demo-copy-embed" className="inline-flex items-center gap-1.5 text-xs bg-[#f97316] hover:bg-[#ea580c] text-white px-3 py-1.5 rounded-lg">
              {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />} {copied ? "Tersalin" : "Salin Kode"}
            </button>
          </div>
          <pre className="text-xs overflow-x-auto whitespace-pre-wrap" data-testid="demo-embed-code">{EMBED}</pre>
        </div>
      </section>
    </div>
  );
}
